var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCheckfilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM18.665 7.25293C18.2523 6.88601 17.6198 6.92315 17.2529 7.33594L9.95703 15.542L6.70703 12.293L6.61328 12.21C6.22099 11.9049 5.65345 11.9325 5.29297 12.293C4.90264 12.6835 4.90265 13.3165 5.29297 13.707L9.29297 17.707L9.38379 17.7881C9.79331 18.1094 10.3931 18.0634 10.748 17.6641L18.748 8.66406L18.8252 8.56543C19.1066 8.15604 19.0457 7.59166 18.665 7.25293Z",
    fill: "#00AD3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckfilled);
export default __webpack_public_path__ + "static/media/Circle Check (filled).7c965973d0f99adfe49b4a2dacfa78df.svg";
export { ForwardRef as ReactComponent };